<template>
    <div>
        <div>
            <div class="qiu-container">
                <h1>{{ selectedPrize ? selectedPrize.awardname : '请选择奖项' }}</h1>

                <div class="threejs-photo-wall">
                    <canvas ref="photoWallCanvas"></canvas>
                </div>

                <!-- <div class="result-panel" v-if="winners.length > 0">
                    <h3>中奖名单</h3>
                    <div class="winners-list">
                        <div v-for="(winner, index) in winners" :key="index" class="winner-item">
                            <span class="winner-name">{{ winner.name }}</span>
                            <span class="winner-prize">{{ winner.prize }}</span>
                        </div>
                    </div>
                </div> -->
            </div>

            <div class="bigboxs">

                <div class="control-panel">
                    <!-- 背景音乐控制按钮 -->
                    <button @click="toggleBgm" class="bgm-control">
                        {{ isBgmPlaying ? '🔊 关闭音乐' : '🎵 播放音乐' }}
                    </button>

                    <div class="prize-selector">
                        <label>选择奖项：</label>
                        <select v-model="selectedPrize" @change="onPrizeChange">
                            <option v-for="prize in jiangxiang" :key="prize.id" :value="prize">
                                {{ prize.awardname }} (剩余: {{ getRemainingCount(prize) }}/{{
                                    prize.prizenum }}){{ isPrizeDrawn(prize) ? '【已抽奖】' : '' }}
                            </option>
                        </select>
                    </div>



                    <div class="lottery-info">
                        <span>每次抽取: {{ selectedPrize ? selectedPrize.onceout : 0 }} 人</span>
                        <span>已抽次数/要抽次数: {{ getDrawnTimes(selectedPrize) }}/{{ getTotalTimes(selectedPrize) }}</span>
                    </div>

                    <button class="start-btn" @click="toggleLottery" :disabled="!canDraw">
                        {{ isDrawing ? '停止抽奖' : '开始抽奖' }}
                    </button>

                </div>
            </div>

            <!-- 中奖弹窗 -->
            <div v-if="showWinnerModal" class="winner-modal-overlay" @click="closeWinnerModal">
                <div class="winner-modal" @click="closeWinnerModal">

                    <div class="modal-content">
                        <div class="prize-section">
                            <div class="prize-image">

                                <img :src="currentPrizeImage" :alt="currentPrizeName" v-if="currentPrizeImage">

                            </div>

                        </div>
                        <div class="winners-section">

                            <div class="winners-list-modal">
                                <div v-for="(winner, index) in currentWinners" :key="index" class="winner-item-modal">
                                    <img v-if="winner.avatar" :src="winner.avatar" :alt="winner.name"
                                        class="winner-avatar-modal">
                                    <div v-else class="winner-avatar-placeholder">{{ getWinnerInitial(winner.name) }}
                                    </div>
                                    <span v-if="winner.name" class="winner-name-modal">{{ winner.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 微信浏览器遮罩层 -->
        <div v-if="isWechatBrowser" class="wechat-mask">
            <div class="wechat-mask-content">
                <h2>程序出错</h2>
                <p>请联系客服</p>
            </div>
        </div>
    </div>
</template>

<script>

import * as THREE from 'three';
import request from '@/utils/request';

export default {
    name: 'Qiu',
    data() {
        return {
            // 背景音乐
            bgm: null,
            isBgmPlaying: false,

            // 参与人员列表
            participants: [],

            // 新的奖项设置
            jiangxiang: [
                {
                    "id": 1,
                    "awardname": "幸运奖",
                    "prizename": "幸运奖",
                    "prizenum": 10,
                    "onceout": 10,
                    "prizeimage": "https://dapingnew.mytopall.cn/theimages/taodao.png"
                },
                {
                    "id": 2,
                    "awardname": "三等奖",
                    "prizename": "九阳电饭煲",
                    "prizenum": 3,
                    "onceout": 3,
                    "prizeimage": "https://dapingnew.mytopall.cn/theimages/dianfanguo.png"
                },
                {
                    "id": 3,
                    "awardname": "二等奖",
                    "prizename": "摩飞锅",
                    "prizenum": 2,
                    "onceout": 2,
                    "prizeimage": "https://dapingnew.mytopall.cn/theimages/mofei.png"
                },
                {
                    "id": 4,
                    "awardname": "一等奖",
                    "prizename": "戴森吹风机",
                    "prizenum": 2,
                    "onceout": 2,
                    "prizeimage": "https://dapingnew.mytopall.cn/theimages/chuifengji.png"
                }
            ],

            selectedPrize: null,
            isDrawing: false,
            currentDrawCount: 0,
            winners: [],
            drawnRecords: {},
            drawnPrizeIds: [],
            winRecords: [],
            scene: null,
            camera: null,
            renderer: null,

            // 弹窗相关
            showWinnerModal: false,
            currentPrizeImage: '',
            currentPrizeName: '',
            currentWinners: [],
            photoGroup: null,
            animationId: null,
            names: [],
            rotationSpeed: 0.001,
            isWechatBrowser: false,
        };
    },
    computed: {
        canDraw() {
            if (!this.selectedPrize) return false;
            const remaining = this.getRemainingCount(this.selectedPrize);
            return remaining > 0 && this.availableParticipants.length > 0;
        },
        availableParticipants() {
            const allDrawnNames = this.getAllDrawnNames();
            return this.participants.filter(person => !allDrawnNames.includes(person.name));
        }
    },
    async mounted() {


        // 检测是否为微信浏览器
        const ua = navigator.userAgent.toLowerCase();
        this.isWechatBrowser = /micromessenger/.test(ua);
        await this.fetchPrizes();
        await this.fetchWinRecords();
        // 初始化背景音乐
        this.initBgm();
        // 请求参与人员列表
        this.fetchParticipants();
        this.showMockWinnerModalIfNeeded();
    },
    methods: {
        // 中奖弹窗预览：临时直接弹出，确认效果后删除这个方法和 mounted 里的调用即可
        showMockWinnerModalIfNeeded() {
            this.currentPrizeName = '二等奖';
            this.currentPrizeImage = 'https://yiyufenfen.oss-cn-beijing.aliyuncs.com/red-lottery/KSXU4612NQWK/ec985ef2-1110-436a-9f3c-dd14ba4959d7.png';
            this.currentWinners = [
                {
                    name: '张*',
                    avatar: 'https://yiyufenfen.oss-cn-beijing.aliyuncs.com/red-lottery/06d7c59b-a9e0-4268-a2c4-baacabd7513f.jpeg'
                },
                { name: '李*明', avatar: '' },
                { name: '王*', avatar: '' },
                { name: '赵*华', avatar: '' },
                { name: '刘*', avatar: '' },
                { name: '陈*强', avatar: '' },
                { name: '李*明', avatar: '' },
                { name: '王*', avatar: '' },
                { name: '赵*华', avatar: '' },
                { name: '刘*', avatar: '' },
                { name: '陈*强', avatar: '' },
                { name: '刘*', avatar: '' },
                { name: '陈*强', avatar: '' },
                { name: '李*明', avatar: '' },
                { name: '王*', avatar: '' },
                { name: '赵*华', avatar: '' },
                { name: '刘*', avatar: '' },
                { name: '陈*强', avatar: '' }
            ];
            this.showWinnerModal = true;
        },

        // 初始化背景音乐
        initBgm() {
            try {
                this.bgm = new Audio(require('/static/bgm.mp3'));
                this.bgm.loop = true;
                this.bgm.volume = 0.3;
            } catch (error) {
                console.error('背景音乐加载失败:', error);
            }
        },
        // 切换背景音乐播放状态
        toggleBgm() {
            if (!this.bgm) return;

            if (this.isBgmPlaying) {
                this.bgm.pause();
            } else {
                this.bgm.play().catch(error => {
                    console.error('背景音乐播放失败:', error);
                });
            }
            this.isBgmPlaying = !this.isBgmPlaying;
        },
        // 获取大屏奖项列表
        async fetchPrizes() {
            try {
                const code = this.getActivityCode();
                const response = await request.get('/api/prize/listByCode', {
                    params: { code }
                });

                if (response.data.code === 200 && Array.isArray(response.data.data)) {
                    this.jiangxiang = response.data.data.map(prize => ({
                        ...prize,
                        awardname: prize.name,
                        prizename: prize.name,
                        prizenum: Number(prize.drawPersonCount || 0),
                        onceout: Number(prize.drawPersonCount || 0),
                        prizeimage: this.cleanImageUrl(prize.image)
                    })).filter(prize => prize.prizenum > 0);
                    this.selectedPrize = this.jiangxiang[0] || null;
                }
            } catch (error) {
                console.error('获取奖项列表失败:', error);
                alert('获取奖项列表失败，请稍后重试');
            }
        },

        // 获取中奖记录，用于判断奖项是否已抽过
        async fetchWinRecords() {
            try {
                const code = this.getActivityCode();
                const response = await request.get('/api/lottery/mobile/winRecords', {
                    params: {
                        page: 1,
                        page_size: 10000,
                        code,
                        phone: ''
                    }
                });

                if (response.data.code === 200) {
                    const data = response.data.data || {};
                    const records = Array.isArray(data.records) ? data.records
                        : Array.isArray(data.list) ? data.list
                            : Array.isArray(data) ? data
                                : [];
                    this.winRecords = records;
                    this.drawnPrizeIds = this.jiangxiang
                        .filter(prize => records.some(record => this.isSamePrizeRecord(record, prize)))
                        .map(prize => prize.id);
                }
            } catch (error) {
                console.error('获取中奖记录失败:', error);
            }
        },

        // 获取参与人员列表
        async fetchParticipants() {
            try {
                const code = this.getActivityCode();
                const count = 200;
                const response = await request.get('/api/user/randomUsers', {
                    params: {
                        code,
                        count
                    }
                });

                if (response.data.code === 200) {
                    this.participants = response.data.data.map(this.normalizeParticipant);
                    this.names = this.participants;
                    this.initThreeJSPhotoWall();
                }
            } catch (error) {
                console.error('获取参与人员失败:', error);
                alert('获取参与人员失败，请稍后重试');
            }
        },

        getActivityCode() {
            if (this.$route && this.$route.query && this.$route.query.code) {
                return this.$route.query.code;
            }
            return new URLSearchParams(window.location.search).get('code') || '';
        },

        normalizeParticipant(person) {
            const name = person.username || person.name || '';
            return {
                ...person,
                name,
                maskedName: this.maskName(name),
                avatar: this.cleanAvatarUrl(person.wxAvatar || person.avatar || '')
            };
        },

        maskName(name) {
            if (!name) return '';
            if (name.length === 1) return name;
            if (name.length === 2) return `${name[0]}*`;
            return `${name[0]}${'*'.repeat(name.length - 2)}${name[name.length - 1]}`;
        },

        cleanAvatarUrl(url) {
            return (url || '').replace(/`/g, '').trim();
        },

        cleanImageUrl(url) {
            return (url || '').replace(/`/g, '').trim();
        },

        getWinnerInitial(name) {
            return name ? String(name).charAt(0) : '中';
        },

        getRemainingCount(prize) {
            if (!prize) return 0;
            const drawn = this.getDrawnCount(prize);
            return Math.max(0, prize.prizenum - drawn);
        },

        getDrawnCount(prize) {
            if (!prize) return 0;
            return this.drawnRecords[prize.id] ? this.drawnRecords[prize.id].length : 0;
        },

        getDrawnTimes(prize) {
            if (!prize) return 0;
            const drawnCount = this.getDrawnCount(prize);
            return Math.ceil(drawnCount / prize.onceout);
        },

        getTotalTimes(prize) {
            if (!prize) return 0;
            return Math.ceil(prize.prizenum / prize.onceout);
        },

        getAllDrawnNames() {
            const allDrawn = [];
            Object.values(this.drawnRecords).forEach(records => {
                records.forEach(record => {
                    allDrawn.push(record.name);
                });
            });
            return [...new Set(allDrawn)];
        },

        isPrizeDrawn(prize) {
            return !!prize && this.drawnPrizeIds.includes(prize.id);
        },

        getPrizeOptionText(prize) {
            const drawnText = this.isPrizeDrawn(prize) ? '【已抽奖】' : '';
            return `${prize.awardname}${drawnText} (剩余: ${this.getRemainingCount(prize)}/${prize.prizenum})`;
        },

        isSamePrizeRecord(record, prize) {
            if (!record || !prize) return false;

            const recordPrizeId = record.prizeId || record.prize_id || (record.prize && record.prize.id);
            if (recordPrizeId) {
                return String(recordPrizeId) === String(prize.id);
            }

            const recordPrizeName = record.prizeName || record.prize_name || record.name;
            return !!recordPrizeName && String(recordPrizeName).trim() === String(prize.name || prize.prizename || prize.awardname).trim();
        },

        onPrizeChange() {
            // 奖项切换时不需要特殊处理
        },

        async toggleLottery() {
            if (!this.canDraw) return;

            if (this.isDrawing) {
                // 停止抽奖
                this.stopLottery();
            } else {
                // 开始抽奖
                await this.startLottery();
            }
        },

        async startLottery() {
            await this.fetchWinRecords();

            if (this.isPrizeDrawn(this.selectedPrize)) {
                alert('当前奖项已经抽过奖了！');
                return;
            }

            const remaining = this.getRemainingCount(this.selectedPrize);
            const drawCount = Math.min(this.selectedPrize.onceout, remaining, this.availableParticipants.length);

            if (drawCount <= 0) {
                alert('没有可抽奖的人员了！');
                return;
            }

            this.isDrawing = true;
            this.currentDrawCount = drawCount;
            // 快速旋转
            this.rotationSpeed = 0.15;
        },

        stopLottery() {
            // 由快到慢减速停止
            this.decelerateAndStop();
        },

        decelerateAndStop() {
            const decelerate = () => {
                if (this.rotationSpeed > 0.001) {
                    this.rotationSpeed *= 0.95; // 逐渐减速
                    requestAnimationFrame(decelerate);
                } else {
                    this.rotationSpeed = 0.001;
                    this.selectWinners(this.currentDrawCount);
                }
            };
            decelerate();
        },

        async selectWinners(drawCount) {
            try {
                // 调用大屏按奖品抽奖接口，抽取人数由后端按 drawPersonCount 决定
                const response = await request.post('/api/lottery/drawByPrize', {
                    code: this.getActivityCode(),
                    prizeId: this.selectedPrize.id
                });

                if (response.data.code === 200) {
                    const result = response.data.data || {};
                    const selectedWinners = (result.winResults || []).map(this.normalizeParticipant);

                    // 使用Vue.set确保响应式更新
                    if (!this.drawnRecords[this.selectedPrize.id]) {
                        this.$set(this.drawnRecords, this.selectedPrize.id, []);
                    }

                    selectedWinners.forEach(winner => {
                        this.drawnRecords[this.selectedPrize.id].push({
                            name: winner.name,
                            prize: this.selectedPrize.prizename,
                            time: new Date().toLocaleString()
                        });
                        this.winners.push({
                            name: winner.name,
                            prize: this.selectedPrize.prizename
                        });
                    });

                    // 强制更新drawnRecords以触发计算属性重新计算
                    this.drawnRecords = { ...this.drawnRecords };
                    if (!this.drawnPrizeIds.includes(this.selectedPrize.id)) {
                        this.drawnPrizeIds = [...this.drawnPrizeIds, this.selectedPrize.id];
                    }

                    this.isDrawing = false;
                    // 重新创建照片墙，移除已中奖人员
                    this.names = this.availableParticipants;
                    this.createPhotoWall();

                    // 显示中奖弹窗
                    this.currentPrizeName = this.selectedPrize.prizename;
                    this.currentPrizeImage = this.selectedPrize.prizeimage;
                    this.currentWinners = selectedWinners.map(person => ({
                        name: person.maskedName,
                        avatar: person.avatar
                    }));
                    this.showWinnerModal = true;

                    // 检查当前奖项是否已抽完
                    if (this.getDrawnCount(this.selectedPrize) >= this.selectedPrize.prizenum) {
                        const currentIndex = this.jiangxiang.findIndex(prize => prize.id === this.selectedPrize.id);
                        const nextIndex = currentIndex + 1;

                        // 如果有下一个奖项，自动选择
                        if (nextIndex < this.jiangxiang.length) {
                            this.selectedPrize = this.jiangxiang[nextIndex];
                        }
                    }
                } else {
                    this.isDrawing = false;
                    alert('抽奖失败：' + response.data.msg);
                }
            } catch (error) {
                console.error('抽奖失败:', error);
                this.isDrawing = false;
                alert('抽奖失败，请稍后重试');
            }
        },

        resetLottery() {
            if (confirm('确定要重置所有抽奖记录吗？')) {
                this.drawnRecords = {};
                this.winners = [];
                this.names = this.participants;
                this.createPhotoWall();
            }
        },

        closeWinnerModal() {
            this.showWinnerModal = false;
            this.currentPrizeImage = '';
            this.currentPrizeName = '';
            this.currentWinners = [];
        },

        async initThreeJSPhotoWall() {
            const canvas = this.$refs.photoWallCanvas;
            const container = canvas.parentElement;

            canvas.width = container.clientWidth;
            canvas.height = container.clientHeight;

            this.scene = new THREE.Scene();
            this.scene.background = null;

            const aspect = canvas.width / canvas.height;
            this.camera = new THREE.PerspectiveCamera(75, aspect, 0.1, 1000);
            this.camera.position.set(0, 0, 50);
            this.camera.lookAt(0, 0, 0);

            this.renderer = new THREE.WebGLRenderer({
                canvas,
                antialias: true,
                alpha: true
            });
            this.renderer.setSize(canvas.width, canvas.height);
            this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));

            this.photoGroup = new THREE.Group();
            this.scene.add(this.photoGroup);

            await this.createPhotoWall();

            this.animate();

            window.addEventListener('resize', this.onWindowResize);
        },

        async createPhotoWall() {
            if (this.photoGroup.children.length > 0) {
                while (this.photoGroup.children.length > 0) {
                    const child = this.photoGroup.children[0];
                    if (child.geometry) child.geometry.dispose();
                    if (child.material) {
                        if (Array.isArray(child.material)) {
                            child.material.forEach(m => m.dispose());
                        } else {
                            child.material.dispose();
                        }
                    }
                    this.photoGroup.remove(child);
                }
            }

            if (this.names.length === 0) return;

            const totalNames = this.names.length;
            const goldenRatio = (1 + Math.sqrt(5)) / 2;
            const radius = 23;

            const nameTextures = [];
            const namePositions = [];

            for (let i = 0; i < totalNames; i++) {
                const theta = 2 * Math.PI * i / goldenRatio;
                const phi = Math.acos(1 - 2 * (i + 0.5) / totalNames);

                const x = radius * Math.sin(phi) * Math.cos(theta);
                const y = radius * Math.sin(phi) * Math.sin(theta);
                const z = radius * Math.cos(phi);

                namePositions.push({ x, y, z });
                nameTextures.push(await this.createAvatarTexture(this.names[i]));
            }

            const geometry = new THREE.PlaneGeometry(3.2, 3.2);

            for (let i = 0; i < totalNames; i++) {
                const material = new THREE.MeshBasicMaterial({
                    map: nameTextures[i],
                    side: THREE.DoubleSide,
                    transparent: true
                });

                const mesh = new THREE.Mesh(geometry, material);
                mesh.position.set(namePositions[i].x, namePositions[i].y, namePositions[i].z);
                // 让名字始终朝向相机
                mesh.lookAt(this.camera.position);

                this.photoGroup.add(mesh);
            }
        },

        createAvatarTexture(person) {
            return new Promise(resolve => {
                const canvas = document.createElement('canvas');
                canvas.width = 256;
                canvas.height = 256;
                const ctx = canvas.getContext('2d');
                const finish = () => {
                    const texture = new THREE.CanvasTexture(canvas);
                    texture.needsUpdate = true;
                    resolve(texture);
                };
                const drawRoundRect = (x, y, width, height, radius) => {
                    ctx.beginPath();
                    ctx.moveTo(x + radius, y);
                    ctx.lineTo(x + width - radius, y);
                    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
                    ctx.lineTo(x + width, y + height - radius);
                    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
                    ctx.lineTo(x + radius, y + height);
                    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
                    ctx.lineTo(x, y + radius);
                    ctx.quadraticCurveTo(x, y, x + radius, y);
                    ctx.closePath();
                };
                const drawFallback = () => {
                    ctx.clearRect(0, 0, 256, 256);
                    ctx.fillStyle = '#F1E07C';
                    drawRoundRect(8, 8, 240, 240, 24);
                    ctx.fill();
                    ctx.fillStyle = '#cc0000';
                    ctx.font = 'bold 80px Arial';
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText((person.maskedName || '奖').slice(0, 2), 128, 128);
                    finish();
                };

                if (!person.avatar) {
                    drawFallback();
                    return;
                }

                const image = new Image();
                image.crossOrigin = 'anonymous';
                image.onload = () => {
                    ctx.clearRect(0, 0, 256, 256);
                    ctx.save();
                    drawRoundRect(8, 8, 240, 240, 24);
                    ctx.clip();
                    ctx.drawImage(image, 8, 8, 240, 240);
                    ctx.restore();
                    ctx.strokeStyle = '#F1E07C';
                    ctx.lineWidth = 10;
                    drawRoundRect(8, 8, 240, 240, 24);
                    ctx.stroke();
                    finish();
                };
                image.onerror = drawFallback;
                image.src = person.avatar;
            });
        },

        animate() {
            this.animationId = requestAnimationFrame(this.animate);

            this.photoGroup.rotation.y -= this.rotationSpeed;

            // 让所有名字面板始终朝向相机
            this.photoGroup.children.forEach(mesh => {
                if (mesh instanceof THREE.Mesh) {
                    mesh.lookAt(this.camera.position);
                }
            });

            this.renderer.render(this.scene, this.camera);
        },

        onWindowResize() {
            const canvas = this.$refs.photoWallCanvas;
            const container = canvas.parentElement;
            canvas.width = container.clientWidth;
            canvas.height = container.clientHeight;
            this.camera.aspect = canvas.width / canvas.height;
            this.camera.updateProjectionMatrix();
            this.renderer.setSize(canvas.width, canvas.height);
        },
    },
};
</script>

<style scoped>
.qiu-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url('../assets/thebgs.jpg');
    background-size: cover;
    background-position: center;
    overflow: hidden;
}

h1 {
    color: #ffd700;
    margin: 20px 0;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    font-size: 2.5em;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
}

.bigboxs {
    position: fixed;
    bottom: 0px;
    left: 50%;
    width: 100%;
    height: 100px;
    transform: translateX(-50%);
}

.bigboxs:hover .control-panel {
    transform: translateY(0);
}

.control-panel {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    gap: 20px;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    padding: 20px 30px;
    box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.3);
    flex-wrap: wrap;
    justify-content: center;
    color: white;
    width: 100%;
    transition: all 0.3s ease-in-out;
    transform: translateY(100%);
}

.bgm-control {
    background-color: #F1E07C;
    color: #520002;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.bgm-control:hover {
    background-color: #fff;
    transform: scale(1.05);
}

.prize-selector {
    display: flex;
    align-items: center;
    gap: 10px;
}

.prize-selector label {
    font-weight: bold;
    color: white;
}

.prize-selector select {
    padding: 10px 15px;
    border: 2px solid #ff6b6b;
    border-radius: 8px;
    font-size: 16px;
    background: rgba(255, 255, 255, 0.9);
    cursor: pointer;
    min-width: 300px;
}

.lottery-info {
    display: flex;
    gap: 20px;
    color: white;
    font-weight: bold;
}

.start-btn {
    padding: 12px 30px;
    background: linear-gradient(135deg, #990000 0%, #ae0000 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
}

.start-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 107, 107, 0.4);
}

.start-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.reset-btn {
    padding: 12px 30px;
    background: linear-gradient(135deg, #f87200 0%, #ff0000 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
}

.reset-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(78, 205, 196, 0.4);
}

.reset-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.threejs-photo-wall {
    flex: 1;
    width: 100%;
    position: relative;
}

.threejs-photo-wall canvas {
    width: 100%;
    height: 100%;
}

.result-panel {
    position: fixed;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.95);
    padding: 20px;
    border-radius: 15px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    max-height: 70vh;
    overflow-y: auto;
    width: 350px;
    z-index: 1000;
}

.result-panel h3 {
    margin-top: 0;
    color: #333;
    text-align: center;
    border-bottom: 2px solid #667eea;
    padding-bottom: 10px;
}

.winners-list {
    max-height: 60vh;
    overflow-y: auto;
}

.winner-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin: 5px 0;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border-radius: 8px;
    animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(20px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.winner-name {
    font-weight: bold;
    color: #333;
}

.winner-prize {
    font-size: 12px;
    color: #666;
    text-align: right;
}

/* 中奖弹窗样式 */
.winner-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(8px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: fadeIn 0.25s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.winner-modal {
    width: 50vw;
    max-width: 92%;
    max-height: 88vh;
    overflow: hidden;
    border-radius: 24px;
    animation: popIn 0.3s ease-out;
    color: #fff;
}

@keyframes popIn {
    from {
        opacity: 0;
        transform: translateY(24px) scale(0.96);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.modal-header {
    padding: 24px 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.06);
}

.modal-header h2 {
    margin: 0;
    color: #fff;
    font-size: 34px;
    font-weight: 700;
    letter-spacing: 6px;
}

.close-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    font-size: 28px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.close-btn:hover {
    background: rgba(255, 255, 255, 0.22);
}

.modal-content {}

.prize-section,
.winners-section {
    border-radius: 20px;
}

.prize-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.prize-image {
    width: 100%;
    max-width: 420px;
    aspect-ratio: 1;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.prize-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.prize-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #222;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    padding: 20px;
}

.prize-name {
    margin-top: 18px;
    font-size: 24px;
    color: #fff;
    font-weight: 700;
    text-align: center;
}

.winners-section {
    padding: 24px;
    min-width: 0;
}

.winners-section h3 {
    margin: 0 0 20px 0;
    color: #fff;
    font-size: 26px;
    text-align: center;
    padding-bottom: 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.16);
}

.winners-list-modal {
    max-height: 440px;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: flex-start;
    gap: 16px;
    padding-right: 6px;
}

.winner-item-modal {
    width: 140px;
    min-height: 170px;
    padding: 18px 12px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.winner-avatar-modal,
.winner-avatar-placeholder {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    margin-bottom: 12px;
}

.winner-avatar-modal {
    object-fit: cover;
    background: #f2f3f5;
}

.winner-avatar-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 34px;
    font-weight: 700;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.winner-name-modal {
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
    text-align: center;
    word-break: break-all;
}

.modal-footer {
    padding: 22px 32px 30px;
    display: flex;
    justify-content: center;
    border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.confirm-btn {
    min-width: 160px;
    padding: 14px 48px;
    background: #fff;
    color: #1f2937;
    border: none;
    border-radius: 999px;
    font-size: 20px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease;
}

.confirm-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 12px 30px rgba(255, 255, 255, 0.18);
}


/* 微信浏览器遮罩层 */
.wechat-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;
}

.wechat-mask-content {
    text-align: center;
    color: white;
    padding: 60px;
    background: #850000;
    border-radius: 20px;
    box-shadow: 0 0 50px rgba(255, 0, 0, 0.5);
}

.wechat-mask-content h2 {
    font-size: 3em;
    margin-bottom: 20px;
    color: #ffd700;
}

.wechat-mask-content p {
    font-size: 1.5em;
    color: #ffffff;
}
</style>
